import { useQuery } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { ExtractFnReturnType, QueryConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

import { INBOX_API_KEY } from '../../../../api/config';

// const url = `${PREFIX_URL}/v01/inboxThread/details`;
const url = `${PREFIX_URL}/inbox-threads/:inboxEntryId/emails/:emailId`;

type EmailEntryDetailResponse = {
  data: any;
  status: boolean;
};

export const getEmailEntryDetail = ({
  inboxEntryId,
  projectId,
  emailId,
}): Promise<EmailEntryDetailResponse> => {
  return axios.get(generateRoutePath(url, { projectId, inboxEntryId, emailId }));
};

export const emailEntryKeys = {
  all: ['emailEntryDetail'] as const,
  detail: (filters: { emailId: number; inboxEntryId: number; projectId: string }) =>
    [INBOX_API_KEY, ...emailEntryKeys.all, { ...filters }] as const,
};

type QueryFnType = typeof getEmailEntryDetail;

type useEmailEntryDetailOptions = {
  projectId: string;
  emailId: number;
  inboxEntryId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useEmailEntry = ({ emailId, config, ...otherParams }: useEmailEntryDetailOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: [INBOX_API_KEY, ...emailEntryKeys.all, { emailId, ...otherParams }],
    queryFn: () => getEmailEntryDetail({ emailId, ...otherParams }),
    staleTime: Infinity,
    ...config,
  });
};
